import { render, staticRenderFns } from "./link-point-of-sale.vue?vue&type=template&id=c42575c6&"
import script from "./link-point-of-sale.vue?vue&type=script&lang=js&"
export * from "./link-point-of-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports